import { ChangeDetectorRef, Injector, Provider } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicDialogService } from '@common/ui/frontend-shared/dynamic-dialog';
import { LocalMessageHandlerService } from "@core/frontend-shared";
import { ConfigService } from '@core/shared/config';
import { map } from 'rxjs/operators';
import { CrudControllerFactory } from '../controller/controller-factory';
import { CrudManagerService } from './crud-manager.service';
import { AsyncPipe } from '@angular/common';
import { CrudManagerLayoutTableComponent } from './layouts/layout-table.component';
import { CrudManagerLayoutListComponent } from './layouts/layout-list.component';
import { CRUD_ITEM_VIEW_SERVICE_TOKEN, CrudItemViewServiceCrudManager } from '../crud-editor';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@core/shared/config";
import * as i3 from "./crud-manager.service";
import * as i4 from "@core/frontend-shared";
function CrudManager2Component_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "crud-manager-layout-table", 0);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("componentDisplay", i0.ɵɵpipeBind1(1, 2, ctx_r0.componentDisplay$))("infoMessage", ctx_r0.infoMessage);
  }
}
function CrudManager2Component_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "crud-manager-layout-list", 0);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("componentDisplay", i0.ɵɵpipeBind1(1, 2, ctx_r0.componentDisplay$))("infoMessage", ctx_r0.infoMessage);
  }
}
export const CrudManager2Template = {
  providers: [LocalMessageHandlerService, CrudManagerService, CrudItemViewServiceCrudManager, {
    provide: CRUD_ITEM_VIEW_SERVICE_TOKEN,
    useExisting: CrudItemViewServiceCrudManager
  }, CrudControllerFactory, DynamicDialogService],
  styles: [``],
  template: `
	@if(config.layout.name === 'table') {
		<crud-manager-layout-table [componentDisplay]="componentDisplay$|async" [infoMessage]="infoMessage"></crud-manager-layout-table>
	} @else if (config.layout.name==='list') {
		<crud-manager-layout-list [componentDisplay]="componentDisplay$|async" [infoMessage]="infoMessage"></crud-manager-layout-list>
	}
	`
};
export let CrudManager2Component = /*#__PURE__*/(() => {
  class CrudManager2Component {
    /**
     * NOTE: initially, cruManager initialization was handled by setupCrudManager executed synchronously within constructor.
     * This resulted in issues with child component dependencies not being available yet.
     * For that reason, crudManager was rewritten to use a getter which will run setupCrudManager when first accessing it.
     */
    get crudManager() {
      if (!this.__crudManager.configurated) {
        this.setupCrudManager();
      }
      return this.__crudManager;
    }
    get modeAndItem$() {
      return this.crudManager.modeAndItem$;
    }
    get componentDisplay$() {
      return this.modeAndItem$.pipe(map(({
        mode
      }) => {
        const list = mode === 'list';
        const batchEditor = mode === 'batch';
        return {
          list,
          batchEditor,
          editor: !list && !batchEditor
        };
      }));
    }
    get config() {
      return this.crudManager.config;
    }
    get service() {
      return this.crudManager.service;
    }
    get restraints() {
      return this.crudManager.restraints;
    }
    // DO NOT OVERRIDE. use inject() or override injectExtraDependencies(),
    constructor(cd, route, router, configService, crudManager, inject, messages) {
      this.cd = cd;
      this.route = route;
      this.router = router;
      this.configService = configService;
      this.inject = inject;
      this.messages = messages;
      this.displayList = true;
      this.displayEditor = false;
      this.displayBatchEditor = false;
      this.routeParamKeyForItemId = 'id';
      this.__crudManager = crudManager;
      this.injectExtraDependencies(inject);
    }
    injectExtraDependencies(injector) {}
    // override to pass a number of custom template components for use in list/editor crud components
    getTemplates() {
      return {};
    }
    // NOTE: For customization, override initializeCrudManager()
    setupCrudManager() {
      this.__crudManager.configurate(this.getConfig(), this.getModel(), this.getCustomItemService(), this.getTemplates(), this.router, this.route);
      this.__crudManager.setFormServiceCustomizer((fs, item) => {
        if (this.customizeFormService) fs = this.customizeFormService(fs, item);
        return fs;
      });
      this.initializeCrudManager();
      this.__crudManager.afterInitialize();
    }
    // called after setup is completed and CrudManager is ready for use
    // to customize formService, it is recommended to define customizeFormService(fs) method
    initializeCrudManager() {}
    getCustomItemService() {
      return false;
    }
    // called by CrudManagerService during FormService setup BEFORE service initialization
    customizeFormService(formService, item) {
      return formService;
    }
    setTitle(title) {
      this.crudManager.setPageTitle(title);
    }
    onCloseEditor($event) {
      // console.log('onCloseEditor should work without calling configurateModeAndItem manually')
      // this.crudManager.configurateModeAndItem(null);
      this.router.navigate(['./'], {
        relativeTo: this.route.parent
      });
    }
    getItemActions() {
      return this.config.itemActions;
    }
    static {
      this.ɵfac = function CrudManager2Component_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CrudManager2Component)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.ConfigService), i0.ɵɵdirectiveInject(i3.CrudManagerService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i4.LocalMessageHandlerService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CrudManager2Component,
        selectors: [["ng-component"]],
        features: [i0.ɵɵProvidersFeature(CrudManager2Template.providers)],
        decls: 2,
        vars: 1,
        consts: [[3, "componentDisplay", "infoMessage"]],
        template: function CrudManager2Component_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, CrudManager2Component_Conditional_0_Template, 2, 4, "crud-manager-layout-table", 0)(1, CrudManager2Component_Conditional_1_Template, 2, 4, "crud-manager-layout-list", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.config.layout.name === "table" ? 0 : ctx.config.layout.name === "list" ? 1 : -1);
          }
        },
        dependencies: [CrudManagerLayoutTableComponent, CrudManagerLayoutListComponent, AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return CrudManager2Component;
})();